import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import { useTranslation } from '../../../Context/LanguageContext';
const { REACT_APP_SITE_KEY } = process.env;

const LoginForm = (props) => {
  const [captchaCheck, setCaptchaCheck] = useState(false);
  const { t } = useTranslation();

  const handleCaptaChange = (val) => {
    setCaptchaCheck(val !== null);
  };

  const { handleSubmit, handleChange, values, errors, isLoading } = props;

  return (
    <>
      <Form role='form' onSubmit={handleSubmit}>
        <div className='mb-3'>
          <input
            className='form-control form-control-lg'
            placeholder={t('email')}
            aria-label={t('email')}
            type='email'
            name='email'
            value={values.email}
            onChange={handleChange}
          />
          {errors.email && (
            <small className='text-danger ps-2'>{errors.email}</small>
          )}
        </div>
        <div className='mb-3'>
          <input
            className='form-control form-control-lg'
            placeholder={t('password')}
            aria-label={t('password')}
            type='password'
            name='password'
            value={values.password}
            onChange={handleChange}
          />
          {errors.password && (
            <small className='text-danger ps-2'>{errors.password}</small>
          )}
        </div>
        <div className='d-flex mb-3 justify-content-center gap-3'>
          <div className='form-check'>
            <input
              className='form-check-input'
              type='radio'
              value='Buyer'
              name='role'
              id='roleBuyer'
              onChange={handleChange}
              checked={values.role === 'Buyer'}
            />
            <label className='form-check-label text-muted' htmlFor='roleBuyer'>
              {t('buyer')}
            </label>
          </div>
          <div className='form-check'>
            <input
              className='form-check-input'
              type='radio'
              value='Supplier'
              name='role'
              id='roleSupplier'
              onChange={handleChange}
              checked={values.role === 'Supplier'}
            />
            <label
              className='form-check-label text-muted'
              htmlFor='roleSupplier'
            >
              {t('supplier')}
            </label>
          </div>
        </div>
        <div className='mb-3 recptchaset d-flex justify-content-center'>
          <ReCAPTCHA
            sitekey={REACT_APP_SITE_KEY}
            onChange={handleCaptaChange}
          />
        </div>
        <p className='m-0 text-center'>
          {errors.role && <small className='text-danger'>{errors.role}</small>}
        </p>
        <button
          disabled={!captchaCheck || isLoading}
          type='submit'
          className='btn btn-primary w-100 mt-2 mb-0'
        >
          {isLoading ? (
            <>
              <span
                className='spinner-border spinner-border-sm me-2'
                role='status'
                aria-hidden='true'
              ></span>
              Signing in...
            </>
          ) : (
            t('signIn')
          )}
        </button>
      </Form>
      <div className='card-footer text-center pt-0 px-lg-2 px-1 mt-4 border-0 bg-transparent'>
        <p className='mb-2 text-sm mx-auto text-muted'>
          {t('dontHaveAccount')}
          <Link to='/register' className='text-gold font-weight-bold ms-1'>
            {t('signUp')}
          </Link>
        </p>
        <p className='my-0 text-sm mx-auto'>
          <Link
            to='/forgot-password'
            className='text-muted text-decoration-none'
          >
            {t('forgotPassword')}
          </Link>
        </p>
      </div>
    </>
  );
};

export default LoginForm;
